module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-06.3f7c03ae.jpg";